import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TTodohukenListGetReq, TTodohukenListGetRes } from "./TTodohuken"

/**
 * 都道府県に対するAPIリクエスト用サービス
 *
 * @export
 * @class todohukenService
 * @extends {ConnectApi}
 */
export default class TodohukenService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TTodohukenListGetReq} params
   * @param {(param: TApiResponse<TTodohukenListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TTodohukenListGetRes>) => any} reject
   * @memberof TodohukenService
   */
  getList = async (params?: TTodohukenListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TTodohukenListGetRes>> =
        await this.getInner(`/master/todohuken`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
